(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3336],{

/***/ 26349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ ReplaceKeyword; }
/* harmony export */ });
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25935);

var ReplaceKeyword = function(string, keyword) {
    // avoid dangerous tag
    if (string) {
        var result = string.replace("<", "<span><</span>").replace(keyword, "<em>".concat(keyword, "</em>"));
        // typeof keyword string
        if (keyword && keyword.trim()) {
            return (0,html_react_parser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(result);
        }
        return string;
    }
    return "";
};


/***/ }),

/***/ 58229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92863);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var AutoCompleteList = function(param) {
    var autoCompleteArray = param.autoCompleteArray, handleMouseOver = param.handleMouseOver, selectTarget = param.selectTarget, suggestionIndex = param.suggestionIndex;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_2__.suggestion,
        children: autoCompleteArray.map(function(item, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: suggestionIndex === index ? _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_2__.focus : "",
                onMouseOver: function() {
                    return handleMouseOver(index);
                },
                onClick: function() {
                    return selectTarget(index);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_2__.history
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_2__.text,
                        children: item.text
                    })
                ]
            }, "item".concat(index));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AutoCompleteList);


/***/ }),

/***/ 73471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92863);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80366);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86896);
/* harmony import */ var _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27378);
/* harmony import */ var _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_6__);












var SuggestionList = function(param) {
    var _param_searchHistory = param.searchHistory, searchHistory = _param_searchHistory === void 0 ? true : _param_searchHistory, suggestionArray = param.suggestionArray, handleMouseOver = param.handleMouseOver, selectTarget = param.selectTarget, suggestionIndex = param.suggestionIndex, deleteSearchHistory = param.deleteSearchHistory, setSuggestionArray = param.setSuggestionArray;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var removeSuggestion = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(index) {
            var temp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!searchHistory) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            deleteSearchHistory(suggestionArray[index].text)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        temp = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(suggestionArray.slice(0, index)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(suggestionArray.slice(index + 1, suggestionArray.length)));
                        setSuggestionArray((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(temp));
                        return [
                            2
                        ];
                }
            });
        });
        return function removeSuggestion(index) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderIcon = function(type) {
        if (type === "history") {
            return "query_builder";
        }
        return "trending_up";
    };
    var renderCloseIconButton = function(type, index) {
        if (type === "history") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_6__.close,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    onClick: function() {
                        return removeSuggestion(index);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        className: _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_6__.close
                    })
                })
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_6__.suggestion,
        children: suggestionArray.map(function(suggestionContent, index) {
            var _obj;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    suggestionContent.text ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_6__.suggestionList,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__["default"])((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_6__.focus, suggestionIndex === index)),
                                onMouseOver: function() {
                                    return handleMouseOver(index);
                                },
                                onClick: function() {
                                    return selectTarget(index);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Icon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_9__["default"])((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_6__.trending, suggestionContent.type !== "history"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_6__.history, suggestionContent.type === "history"), _obj)),
                                        children: renderIcon(suggestionContent.type)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_6__.text,
                                        children: suggestionContent.text
                                    })
                                ]
                            }),
                            renderCloseIconButton(suggestionContent.type, index)
                        ]
                    }) : null,
                    suggestionContent.type === "history" && suggestionArray[index + 1] && suggestionArray[index + 1].type === "trending" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: _SearchInput_module_scss__WEBPACK_IMPORTED_MODULE_6__.categoryTitle,
                        children: intl.formatMessage({
                            id: "search.whatsTrending"
                        })
                    }) : null
                ]
            }, "suggestionContent".concat(index));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SuggestionList);


/***/ }),

/***/ 15211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ page_components_ResultNotFound; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/page-components/ResultNotFound/ResultNotFound.module.scss
var ResultNotFound_module = __webpack_require__(9542);
;// CONCATENATED MODULE: ./src/page-components/ResultNotFound/ResultNotFound.js





var ResultNotFound = function(param) {
    var learnerSearchNone = param.learnerSearchNone;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: ResultNotFound_module.resultNotFoundPage,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: ResultNotFound_module.notFoundPageInner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: ResultNotFound_module.imgBox,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/course_no_items.png",
                        width: "238",
                        height: "175",
                        alt: "no_item"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: ResultNotFound_module.content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: ResultNotFound_module.title,
                            children: intl.formatMessage({
                                id: "studio.course.noCoursesSearchFound"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: ResultNotFound_module.subTitle,
                            children: learnerSearchNone ? intl.formatMessage({
                                id: "myJournal.learner.anotherTip"
                            }) : intl.formatMessage({
                                id: "studio.course.anotherTip"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ResultNotFound_ResultNotFound = (ResultNotFound);

;// CONCATENATED MODULE: ./src/page-components/ResultNotFound/index.js

/* harmony default export */ var page_components_ResultNotFound = (ResultNotFound_ResultNotFound);


/***/ }),

/***/ 88432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "courseHandleSearch": function() { return /* binding */ courseHandleSearch; },
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/AppEnv/index.js + 2 modules
var AppEnv = __webpack_require__(70146);
// EXTERNAL MODULE: ./src/components/context/index.ts
var context = __webpack_require__(69142);
// EXTERNAL MODULE: ./src/components/SearchInput/index.js + 1 modules
var SearchInput = __webpack_require__(19140);
// EXTERNAL MODULE: ./src/components/SearchInput/AutoCompleteList.js
var AutoCompleteList = __webpack_require__(58229);
// EXTERNAL MODULE: ./src/components/SearchInput/SuggestionList.js
var SuggestionList = __webpack_require__(73471);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./src/page-components/Footer/index.js + 1 modules
var Footer = __webpack_require__(24990);
// EXTERNAL MODULE: ./src/page-components/Header/index.js
var Header = __webpack_require__(58905);
// EXTERNAL MODULE: ./src/components/Avatar/index.js + 1 modules
var Avatar = __webpack_require__(43255);
// EXTERNAL MODULE: ./src/components/ReplaceKeyword/index.js
var ReplaceKeyword = __webpack_require__(26349);
// EXTERNAL MODULE: ./src/constants/price-setting.js + 2 modules
var price_setting = __webpack_require__(87127);
// EXTERNAL MODULE: ./src/page-components/ViewAllTooltip/index.js + 1 modules
var ViewAllTooltip = __webpack_require__(68411);
// EXTERNAL MODULE: ./src/utils/course-utils.js
var course_utils = __webpack_require__(99465);
// EXTERNAL MODULE: ./src/utils/hooks/use-format-distance-time.js + 1 modules
var use_format_distance_time = __webpack_require__(37059);
// EXTERNAL MODULE: ./src/utils/hooks/use-format-duration.js
var use_format_duration = __webpack_require__(78761);
// EXTERNAL MODULE: ./src/utils/icon-manager.js + 1 modules
var icon_manager = __webpack_require__(22983);
// EXTERNAL MODULE: ./src/utils/image-utils.js + 1 modules
var image_utils = __webpack_require__(23049);
// EXTERNAL MODULE: ./src/utils/number-utils.js
var number_utils = __webpack_require__(98373);
// EXTERNAL MODULE: ./src/utils/parse-utils.js
var parse_utils = __webpack_require__(80865);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/page-components/ResultItem/ResultItem.module.scss
var ResultItem_module = __webpack_require__(84697);
var ResultItem_module_default = /*#__PURE__*/__webpack_require__.n(ResultItem_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Icon/Icon.js
var Icon = __webpack_require__(92863);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Stars.js
var Stars = __webpack_require__(3426);
// EXTERNAL MODULE: ./src/pages/explore.module.scss
var explore_module = __webpack_require__(32425);
// EXTERNAL MODULE: ./src/utils/video-utils.js
var video_utils = __webpack_require__(62802);
// EXTERNAL MODULE: ./node_modules/react-items-carousel/dist/react-items-carousel.js
var react_items_carousel = __webpack_require__(99902);
var react_items_carousel_default = /*#__PURE__*/__webpack_require__.n(react_items_carousel);
// EXTERNAL MODULE: ./src/page-components/AnnotationViewer/AnnotationViewer.module.scss
var AnnotationViewer_module = __webpack_require__(98981);
;// CONCATENATED MODULE: ./src/page-components/AnnotationViewer/AnnotationViewer.js












var videoWidth = 1000;
var maxLeft = 993;
var AnnotationViewer = function(param) {
    var sectionMarker = param.sectionMarker, importantMarker = param.importantMarker, keyword = param.keyword, duration = param.duration;
    var intl = (0,useIntl/* default */.Z)();
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(0), 2), activeItemIndex = _useState[0], setActiveItemIndex = _useState[1];
    var _useState1 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), clickDropdown = _useState1[0], setClickDropdown = _useState1[1];
    var arrowIcon = function(icon) {
        var arrow;
        switch(icon){
            case "left":
                arrow = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(explore_module.iconBox, " ").concat(explore_module.left),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        children: "keyboard_arrow_left"
                    })
                });
                break;
            case "right":
                arrow = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(explore_module.iconBox, " ").concat(explore_module.right),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        children: "keyboard_arrow_right"
                    })
                });
                break;
            default:
                return null;
        }
        return arrow;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: AnnotationViewer_module.annotationSectionMarkerWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: AnnotationViewer_module.controller,
                onClick: function() {
                    return setClickDropdown(!clickDropdown);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: AnnotationViewer_module.resultText,
                        children: intl.formatMessage({
                            id: "explore.results.videoDetailResultsFound"
                        }, {
                            count: importantMarker.length
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: AnnotationViewer_module.icon,
                        children: (0,icon_manager/* iconManager */.w)(clickDropdown ? "arrowUp" : "arrowDown")
                    })
                ]
            }),
            clickDropdown ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: AnnotationViewer_module.annotationSectionMarker,
                        children: [
                            importantMarker.map(function(marker, index) {
                                var left = (0,video_utils/* leftPercent */.FN)(marker.time, duration, videoWidth, maxLeft);
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        left: "".concat(left, "%")
                                    },
                                    className: activeItemIndex === index ? AnnotationViewer_module.annotationPointFocus : AnnotationViewer_module.annotationPoint,
                                    onClick: function() {
                                        return setActiveItemIndex(index);
                                    }
                                }, "point".concat(index));
                            }),
                            sectionMarker.map(function(item, index) {
                                var color;
                                switch(index){
                                    case 0:
                                        color = AnnotationViewer_module.blue;
                                        break;
                                    case 1:
                                        color = AnnotationViewer_module.green;
                                        break;
                                    case 2:
                                        color = AnnotationViewer_module.purple;
                                        break;
                                    case 3:
                                        color = AnnotationViewer_module.origin;
                                        break;
                                    case 4:
                                        color = AnnotationViewer_module.navyBlue;
                                        break;
                                    default:
                                        return null;
                                }
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: color,
                                    style: {
                                        width: "100%"
                                    }
                                }, "annotationSection".concat(index));
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: AnnotationViewer_module.annotationCardWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_items_carousel_default()), {
                            infiniteLoop: true,
                            requestToChangeActive: setActiveItemIndex,
                            activeItemIndex: activeItemIndex,
                            numberOfCards: 4,
                            gutter: 8,
                            leftChevron: arrowIcon("left"),
                            rightChevron: arrowIcon("right"),
                            outsideChevron: true,
                            chevronWidth: 40,
                            children: importantMarker.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: AnnotationViewer_module.annotationCard,
                                    onClick: function() {
                                        return setActiveItemIndex(index);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars/* default */.Z, {
                                            className: AnnotationViewer_module.star
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: AnnotationViewer_module.annotationContent,
                                            children: (0,ReplaceKeyword/* ReplaceKeyword */.g)(item.title, keyword)
                                        })
                                    ]
                                }, "annotationImportant".concat(index));
                            })
                        })
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var AnnotationViewer_AnnotationViewer = (AnnotationViewer);

;// CONCATENATED MODULE: ./src/page-components/AnnotationViewer/index.js

/* harmony default export */ var page_components_AnnotationViewer = (AnnotationViewer_AnnotationViewer);

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 190 modules
var es = __webpack_require__(9280);
;// CONCATENATED MODULE: ./src/page-components/ResultItem/utils.js


var iconForSkillLevel = function(level) {
    switch(level){
        case 1:
            return (0,icon_manager/* iconManager */.w)("BeginnerLvl", (ResultItem_module_default()).gray500);
        case 2:
            return (0,icon_manager/* iconManager */.w)("IntermediateLvl", (ResultItem_module_default()).gray500);
        case 3:
            return (0,icon_manager/* iconManager */.w)("AdvancedLvl", (ResultItem_module_default()).gray500);
        default:
            return (0,icon_manager/* iconManager */.w)("BeginnerLvl", (ResultItem_module_default()).gray500);
    }
};

;// CONCATENATED MODULE: ./src/page-components/ResultItem/SubResultItem.js




















var SubResultItem = function(param) {
    var data = param.data, keyword = param.keyword, courseInfoId = param.courseInfoId;
    var router = (0,next_router.useRouter)();
    var intl = (0,useIntl/* default */.Z)();
    var formatDuration = (0,use_format_duration/* useFormatDuration */.q)();
    var _ref = data || {}, coverImg = _ref.coverImg, creator = _ref.creator, description = _ref.description, duration = _ref.duration, _ref_learningTarget = _ref.learningTarget, learningTarget = _ref_learningTarget === void 0 ? [] : _ref_learningTarget, _ref_tag = _ref.tag, tag = _ref_tag === void 0 ? [] : _ref_tag, title = _ref.title, type = _ref.type, _ref_sectionMarker = _ref.sectionMarker, sectionMarker = _ref_sectionMarker === void 0 ? [] : _ref_sectionMarker, _ref_importantMarker = _ref.importantMarker, importantMarker = _ref_importantMarker === void 0 ? [] : _ref_importantMarker, skillLevel = _ref.skillLevel;
    var avatar = (creator || {}).avatar;
    var directToCoursePreview = function(event, id) {
        event.preventDefault();
        router.push("/course/preview/".concat(id));
    };
    var isMatch = function(n) {
        return n.length > 0;
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m["default"])((_obj = {}, (0,_define_property/* default */.Z)(_obj, ResultItem_module.itemWrapper, true), (0,_define_property/* default */.Z)(_obj, ResultItem_module.subResultItem, true), _obj)),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: ResultItem_module.itemWrapperInner,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: ResultItem_module.videoWrapper,
                            onClick: function(event) {
                                return directToCoursePreview(event, courseInfoId);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: ResultItem_module.img,
                                style: (0,image_utils/* getBgCSSCourseCoverImg */.M1)(coverImg),
                                children: [
                                    duration ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: ResultItem_module.videoTime,
                                        children: formatDuration(duration)
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: ResultItem_module.icon,
                                        children: (0,icon_manager/* iconManager */.w)("Course")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: ResultItem_module.contentWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: ResultItem_module.itemType,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: ResultItem_module.TypeBox,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: ResultItem_module.icon,
                                                    children: (0,icon_manager/* iconManager */.w)(type)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: ResultItem_module.typeText,
                                                    children: intl.formatMessage({
                                                        id: "common.itemType.".concat(type)
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: ResultItem_module.levelBox,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: ResultItem_module.icon,
                                                    children: iconForSkillLevel(skillLevel)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: ResultItem_module.levelText,
                                                    children: intl.formatMessage({
                                                        id: "common.skillLevel.".concat((0,course_utils/* translateToSkillLevel */.R0)(skillLevel))
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewAllTooltip/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: ResultItem_module.dataScience,
                                        children: (0,ReplaceKeyword/* ReplaceKeyword */.g)(title, keyword)
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewAllTooltip/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: ResultItem_module.disc,
                                        children: (0,ReplaceKeyword/* ReplaceKeyword */.g)(description, keyword)
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: ResultItem_module.author,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, creator), {
                                            width: 24,
                                            src: avatar,
                                            isPointer: false
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: ResultItem_module.publishedTime,
                                            children: (0,parse_utils/* getUserName */.vW)(creator)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: ResultItem_module.covered,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: ResultItem_module.secTitle,
                                            children: intl.formatMessage({
                                                id: "explore.results.whatYouWillLearningCovered"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: learningTarget.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: (0,ReplaceKeyword/* ReplaceKeyword */.g)(item, keyword)
                                                }, "learningTarget".concat(index));
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: ResultItem_module.tags,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: ResultItem_module.secTitle,
                                            children: intl.formatMessage({
                                                id: "explore.results.tagsCovered"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: tag.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: (0,ReplaceKeyword/* ReplaceKeyword */.g)(item, keyword)
                                                }, "tag".concat(index));
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: ResultItem_module.sectionCoveredItem,
                                    children: [
                                        (0,es/* filter */.hXT)(isMatch, sectionMarker).length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: ResultItem_module.secTitle,
                                            children: intl.formatMessage({
                                                id: "explore.results.videoSectionCovered"
                                            })
                                        }) : null,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            children: sectionMarker.map(function(item, index) {
                                                var color;
                                                switch(index){
                                                    case 0:
                                                        color = ResultItem_module.blue;
                                                        break;
                                                    case 1:
                                                        color = ResultItem_module.green;
                                                        break;
                                                    case 2:
                                                        color = ResultItem_module.purple;
                                                        break;
                                                    case 3:
                                                        color = ResultItem_module.origin;
                                                        break;
                                                    case 4:
                                                        color = ResultItem_module.navyBlue;
                                                        break;
                                                    default:
                                                        break;
                                                }
                                                if (item) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        className: color,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "0".concat(index + 1)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: ResultItem_module.keyWord,
                                                                children: (0,ReplaceKeyword/* ReplaceKeyword */.g)(item, keyword)
                                                            })
                                                        ]
                                                    }, "sectionMarker".concat(index));
                                                }
                                                return null;
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                importantMarker.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: ResultItem_module.annotationWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(page_components_AnnotationViewer, {
                        sectionMarker: sectionMarker,
                        importantMarker: importantMarker,
                        keyword: keyword,
                        duration: duration
                    })
                }) : null
            ]
        })
    });
};
/* harmony default export */ var ResultItem_SubResultItem = (SubResultItem);

;// CONCATENATED MODULE: ./src/page-components/ResultItem/ResultItem.js





















var ResultItem = function(param) {
    var data = param.data, keyword = param.keyword, showPrice = param.showPrice;
    var _courseContent_items;
    var router = (0,next_router.useRouter)();
    var intl = (0,useIntl/* default */.Z)();
    var formatDistanceTime = (0,use_format_distance_time/* useFormatDistanceTime */.M)();
    var formatDuration = (0,use_format_duration/* useFormatDuration */.q)();
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), handleClickMoreArrow = _useState[0], setHandleClickMoreArrow = _useState[1];
    var courseInfo = data.courseInfo, courseContent = data.courseContent;
    var directToCourse = function(event, courseId) {
        event.preventDefault();
        router.push("/course/preview/".concat(courseId));
    };
    var _ref = courseInfo || data, coverImg = _ref.coverImg, creator = _ref.creator, description = _ref.description, duration = _ref.duration, enrollCount = _ref.enrollCount, skillLevel = _ref.skillLevel, id = _ref.id, price = _ref.price, publishTime = _ref.publishTime, title = _ref.title, viewCount = _ref.viewCount;
    var _ref1 = creator || {}, _ref_avatar = _ref1.avatar, avatar = _ref_avatar === void 0 ? null : _ref_avatar;
    var showArrowDirection = function(up) {
        if (up) {
            return "arrowUp";
        }
        return "arrowDown";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ResultItem_module.itemWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: ResultItem_module.itemWrapperInner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: ResultItem_module.videoWrapper,
                        href: "/studio/myCourse/".concat(id),
                        onClick: function(event) {
                            return directToCourse(event, id);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: ResultItem_module.img,
                            style: (0,image_utils/* getBgCSSCourseCoverImg */.M1)(coverImg),
                            children: [
                                duration ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: ResultItem_module.videoTime,
                                    children: formatDuration(duration)
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: ResultItem_module.icon,
                                    children: (0,icon_manager/* iconManager */.w)("Course")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: ResultItem_module.contentWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: ResultItem_module.itemType,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: ResultItem_module.TypeBox,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: ResultItem_module.icon,
                                                children: (0,icon_manager/* iconManager */.w)("Course")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: ResultItem_module.typeText,
                                                children: intl.formatMessage({
                                                    id: "common.itemType.course"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: ResultItem_module.levelBox,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: ResultItem_module.icon,
                                                children: iconForSkillLevel(skillLevel)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: ResultItem_module.levelText,
                                                children: intl.formatMessage({
                                                    id: "common.skillLevel.".concat((0,course_utils/* translateToSkillLevel */.R0)(skillLevel))
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewAllTooltip/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: ResultItem_module.dataScience,
                                    children: (0,ReplaceKeyword/* ReplaceKeyword */.g)(title, keyword)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewAllTooltip/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: ResultItem_module.disc,
                                    children: (0,ReplaceKeyword/* ReplaceKeyword */.g)(description, keyword)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: ResultItem_module.author,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, creator), {
                                        width: 24,
                                        src: avatar,
                                        isPointer: false
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: ResultItem_module.publishedTime,
                                        children: (0,parse_utils/* getUserName */.vW)(creator)
                                    }),
                                    publishTime ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: ResultItem_module.publishedTime,
                                        children: [
                                            "\xb7",
                                            " ",
                                            intl.formatMessage({
                                                id: "studio.course.publishDays",
                                                defaultMessage: "Publish • "
                                            }, {
                                                time: formatDistanceTime(publishTime)
                                            })
                                        ]
                                    }) : null
                                ]
                            }),
                            showPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: ResultItem_module.priceItem,
                                children: (0,price_setting/* getCurrencyText */.Y7)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, price), {
                                    intl: intl
                                }))
                            }) : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: ResultItem_module.bottomWrapper,
                children: [
                    (courseContent === null || courseContent === void 0 ? void 0 : (_courseContent_items = courseContent.items) === null || _courseContent_items === void 0 ? void 0 : _courseContent_items.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: ResultItem_module.controller,
                        onClick: function() {
                            return setHandleClickMoreArrow(!handleClickMoreArrow);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: ResultItem_module.resultText,
                                children: intl.formatMessage({
                                    id: "explore.results.resultsFoundCount"
                                }, {
                                    count: courseContent.items.length
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: ResultItem_module.icon,
                                children: (0,icon_manager/* iconManager */.w)(showArrowDirection(handleClickMoreArrow))
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: ResultItem_module.controller
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: ResultItem_module.itemData,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: ResultItem_module.icon,
                                        children: (0,icon_manager/* iconManager */.w)("Views")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: ResultItem_module.number,
                                        title: viewCount,
                                        children: (0,number_utils/* numberAbbr */.Mg)(viewCount)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: ResultItem_module.icon,
                                        children: (0,icon_manager/* iconManager */.w)("Enroll")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: ResultItem_module.number,
                                        title: enrollCount,
                                        children: (0,number_utils/* numberAbbr */.Mg)(enrollCount)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            handleClickMoreArrow && courseContent.items ? courseContent.items.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultItem_SubResultItem, {
                    data: item,
                    keyword: keyword,
                    courseInfoId: id
                }, "subResultItem".concat(index));
            }) : null
        ]
    });
};
/* harmony default export */ var ResultItem_ResultItem = (ResultItem);

;// CONCATENATED MODULE: ./src/page-components/ResultItem/index.js

/* harmony default export */ var page_components_ResultItem = (ResultItem_ResultItem);

// EXTERNAL MODULE: ./src/page-components/ResultItemLayout/ResultItemLayout.module.scss
var ResultItemLayout_module = __webpack_require__(90636);
;// CONCATENATED MODULE: ./src/page-components/ResultItemLayout/ResultItemLayout.js




var ResultItemLayout = function(param) {
    var data = param.data, keyword = param.keyword, showPrice = param.showPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: ResultItemLayout_module.itemContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(page_components_ResultItem, {
            data: data,
            keyword: keyword,
            showPrice: showPrice
        })
    });
};
/* harmony default export */ var ResultItemLayout_ResultItemLayout = (ResultItemLayout);

;// CONCATENATED MODULE: ./src/page-components/ResultItemLayout/index.js

/* harmony default export */ var page_components_ResultItemLayout = (ResultItemLayout_ResultItemLayout);

// EXTERNAL MODULE: ./src/page-components/ResultNotFound/index.js + 1 modules
var ResultNotFound = __webpack_require__(15211);
// EXTERNAL MODULE: ./src/styles/components/customSelectStyles/index.js
var customSelectStyles = __webpack_require__(78063);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 19 modules
var react_select_esm = __webpack_require__(39028);
;// CONCATENATED MODULE: ./src/page-components/SortSelect/SortSelect.js








var SortSelect = function(param) {
    var _param_sortBy = param.sortBy, sortBy = _param_sortBy === void 0 ? "relevance" : _param_sortBy, setSortBy = param.setSortBy;
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var keyword = (0,react.useContext)(context/* default */.ZP).keyword;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)({
        value: sortBy,
        label: intl.formatMessage({
            id: "search.".concat(sortBy)
        })
    }), 2), renderSortBy = _useState[0], setRenderSortBy = _useState[1];
    (0,react.useEffect)(function() {
        setRenderSortBy({
            value: sortBy,
            label: intl.formatMessage({
                id: "search.".concat(sortBy)
            })
        });
    }, [
        sortBy
    ]);
    var directToNewResult = function(select) {
        setSortBy(select.value);
        setRenderSortBy(select);
        router.push("/search?keyword=".concat(encodeURIComponent(keyword), "&sortBy=").concat(select.value));
    };
    var options = [
        {
            value: "relevance",
            label: intl.formatMessage({
                id: "search.relevance"
            })
        },
        {
            value: "mostRecent",
            label: intl.formatMessage({
                id: "search.mostRecent"
            })
        },
        {
            value: "popularity",
            label: intl.formatMessage({
                id: "search.popularity"
            })
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
        isSearchable: false,
        styles: customSelectStyles/* customSelectStyleNoneBorder */.p8,
        options: options,
        onChange: directToNewResult,
        value: renderSortBy
    });
};
/* harmony default export */ var SortSelect_SortSelect = (SortSelect);

;// CONCATENATED MODULE: ./src/page-components/SortSelect/index.js

/* harmony default export */ var page_components_SortSelect = (SortSelect_SortSelect);

// EXTERNAL MODULE: ./src/utils/apiServices/explore.js
var explore = __webpack_require__(8031);
// EXTERNAL MODULE: ./src/utils/hooks/use-central-info.js
var use_central_info = __webpack_require__(82437);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./src/pages/search/relevance.module.scss
var relevance_module = __webpack_require__(90365);
;// CONCATENATED MODULE: ./src/pages/search/index.js

























var SEARCH_LIMIT_WORDS = AppEnv/* scm.search.limit_words */.zE.search.limit_words;
var __N_SSP = true;
var courseHandleSearch = function(router, searchValue) {
    if (!searchValue) {
        return router.push({
            pathname: "/"
        });
    }
    router.push("/search?keyword=".concat(encodeURIComponent(typeof searchValue === "string" ? searchValue.slice(0, SEARCH_LIMIT_WORDS) : searchValue.text.slice(0, SEARCH_LIMIT_WORDS))), undefined, // shallow won't run getServerSideProps again.
    {
        shallow: router.pathname.indexOf("/search") !== -1
    });
};
var Search = function(props) {
    var router = (0,next_router.useRouter)();
    var intl = (0,useIntl/* default */.Z)();
    var baseContext = (0,context/* useAppContext */.bp)();
    var _props_query = props.query, queryTag = _props_query.tag, queryKeyword = _props_query.keyword, querySortBy = _props_query.sortBy;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(null), 2), tag = _useState[0], setTag = _useState[1];
    var _useState1 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(null), 2), keyword = _useState1[0], setKeyword = _useState1[1];
    var _useState2 = (0,_sliced_to_array/* default */.Z)((0,react.useState)([]), 2), searchResultData = _useState2[0], setSearchResultData = _useState2[1];
    var _useState3 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(0), 2), pageNum = _useState3[0], setPageNum = _useState3[1];
    var _useState4 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(true), 2), hasMoreItems = _useState4[0], setHasMoreItems = _useState4[1];
    var _useState5 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(0), 2), totalCount = _useState5[0], setTotalCount = _useState5[1];
    var _useState6 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(querySortBy || "relevance"), 2), sortBy = _useState6[0], setSortBy = _useState6[1];
    var _useState7 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), isLoading = _useState7[0], setIsLoading = _useState7[1];
    var _useCentralInfo = (0,use_central_info/* useCentralInfo */.p)({
        isPublic: true,
        keys: [
            "showPriceWeb"
        ]
    }), showPrice = _useCentralInfo.showPriceWeb;
    var searchContext = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, baseContext), {
        keyword: keyword,
        sortBy: sortBy,
        tag: tag
    });
    var handleSearch = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(searchValue) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                courseHandleSearch(router, searchValue);
                return [
                    2
                ];
            });
        });
        return function handleSearch(searchValue) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderSearchItemList = function() {
        return searchResultData.map(function(data, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(page_components_ResultItemLayout, {
                data: data,
                keyword: keyword,
                showPrice: showPrice
            }, "resultItemLayout".concat(index));
        });
    };
    var fetchData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var type, searchFun, finalPageNum, searchData, _ref, tmp, total, tmp1, newResultData, error, tempArr, error1;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        type = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "scroll";
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (tag === null && keyword === null) {
                            setIsLoading(false);
                            return [
                                2
                            ];
                        }
                        searchFun = tag ? explore/* getSearchResultsByTag */.Xd : explore/* getSearchResult */.s;
                        finalPageNum = type === "init" ? 0 : pageNum;
                        searchData = tag || {
                            keyword: keyword,
                            sortBy: sortBy,
                            pageNum: finalPageNum
                        };
                        return [
                            4,
                            searchFun(searchData)
                        ];
                    case 2:
                        _ref = _state.sent(), tmp = _ref.totalCount, total = tmp === void 0 ? 0 : tmp, tmp1 = _ref.data, newResultData = tmp1 === void 0 ? [] : tmp1, error = _ref.error;
                        if (error) {
                            throw error;
                        }
                        setTotalCount(total);
                        setPageNum(finalPageNum + 1);
                        tempArr = type === "scroll" ? (0,_to_consumable_array/* default */.Z)(searchResultData).concat((0,_to_consumable_array/* default */.Z)(newResultData)) : (0,_to_consumable_array/* default */.Z)(newResultData);
                        setSearchResultData(tempArr);
                        setHasMoreItems(tempArr.length < total);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error1 = _state.sent();
                        console.error("fetchData", error1);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    var transferToSortOrder = function(sortByType) {
        switch(sortByType){
            case "mostRecent":
                return "mostRecent";
            case "popularity":
                return "popularity";
            case "relevance":
            default:
                return "relevance";
        }
    };
    (0,react.useEffect)(function() {
        var _router_query = router.query, queryTagValue = _router_query.tag, queryKeywordValue = _router_query.keyword;
        if (keyword !== queryKeywordValue) {
            setKeyword(queryKeywordValue);
        }
        if (tag !== queryTagValue) {
            setTag(queryTagValue);
        }
    }, [
        keyword,
        queryKeyword,
        queryTag,
        router,
        tag
    ]);
    (0,react.useEffect)(function() {
        setSortBy(transferToSortOrder(querySortBy));
        setPageNum(0);
        setTotalCount(0);
        setSearchResultData([]);
        fetchData("init");
    }, [
        keyword,
        tag,
        querySortBy
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(context/* Provider */.zt, {
        value: searchContext,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, (0,_object_spread/* default */.Z)({}, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: relevance_module.relevancePage,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: relevance_module.searchWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput/* default */.Z, {
                            defaultKeyword: keyword,
                            autoComplete: true,
                            suggestion: true,
                            searchHistory: true,
                            handleSearch: handleSearch,
                            AutoCompleteList: AutoCompleteList/* default */.Z,
                            SuggestionList: SuggestionList/* default */.Z,
                            deleteSearchHistory: explore/* deleteSearchHistory */.Rw,
                            postSearchHistory: explore/* postSearchHistory */.Md,
                            getAutoCompleteList: explore/* getAutoCompleteList */.Bd,
                            getSearchHistory: explore/* getSearchHistory */.nO,
                            getTrendingList: explore/* getTrendingList */.dT
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: relevance_module.relevancePageInner,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: relevance_module.topWrapper,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: relevance_module.searchResult,
                                        children: !isLoading && pageNum === 0 || pageNum > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                intl.formatMessage({
                                                    id: "studio.course.resultMatchCount"
                                                }, {
                                                    count: totalCount
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    children: tag || keyword
                                                })
                                            ]
                                        }) : null
                                    }),
                                    !tag ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: relevance_module.sortItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: intl.formatMessage({
                                                    id: "explore.results.sortBy"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(page_components_SortSelect, {
                                                sortBy: sortBy,
                                                setSortBy: setSortBy
                                            })
                                        ]
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                dataLength: searchResultData.length,
                                next: function() {
                                    return fetchData();
                                },
                                hasMore: hasMoreItems,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: relevance_module.relevanceContainer,
                                    children: [
                                        searchResultData.length ? renderSearchItemList() : null,
                                        isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: relevance_module.loadingWrapper,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
                                        }) : null,
                                        searchResultData.length === 0 && !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultNotFound/* default */.Z, {}) : null
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, (0,_object_spread/* default */.Z)({}, props))
        ]
    });
};
/* harmony default export */ var search = (Search);


/***/ }),

/***/ 78063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ej": function() { return /* binding */ customSelectStylesMini; },
/* harmony export */   "nU": function() { return /* binding */ customSelectStylesGray; },
/* harmony export */   "p8": function() { return /* binding */ customSelectStyleNoneBorder; },
/* harmony export */   "vH": function() { return /* binding */ customSelectStylesRegular; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var customSelectControl = function(styles) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, styles), {
        width: "100%",
        minWidth: "148px",
        height: "100%",
        borderColor: "#fff",
        boxShadow: "0px 1px 2px #00000029",
        borderRadius: "6px",
        "&:hover": {
            borderColor: "transparent"
        }
    });
};
var customSingleValue = function(provided, state) {
    var opacity = state.isDisabled ? 0.5 : 1;
    var transition = "opacity 300ms";
    var color = "#727171";
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, provided), {
        opacity: opacity,
        transition: transition,
        color: color
    });
};
var customOption = function(styles, param) {
    var isFocused = param.isFocused;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, styles), {
        backgroundColor: isFocused ? "#CAEAFE" : isFocused,
        borderBottom: "none",
        position: "relative",
        padding: "15px",
        color: "#727171"
    });
};
var customMenu = function(styles) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, styles), {
        width: "100%",
        boxShadow: "0px 1px 2px #00000029",
        border: "none",
        marginTop: 5
    });
};
var customIndicatorSeparator = function(styles) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, styles), {
        display: "none"
    });
};
var customSelectStylesRegular = {
    control: customSelectControl,
    indicatorSeparator: customIndicatorSeparator,
    menu: customMenu,
    option: customOption,
    singleValue: customSingleValue
};
var customSelectStylesMini = {
    control: customSelectControl,
    indicatorSeparator: customIndicatorSeparator,
    menu: function(styles) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, styles), {
            width: "100%",
            boxShadow: "0px 1px 2px #00000029",
            border: "none",
            marginTop: 5,
            maxHeight: "250px",
            overflow: "hidden"
        });
    },
    option: customOption,
    singleValue: customSingleValue
};
var customSelectStyleNoneBorder = {
    control: function(styles, param) {
        var isFocused = param.isFocused;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, styles), {
            width: "100%",
            minWidth: "148px",
            height: "100%",
            border: "none",
            fontSize: "12px",
            borderColor: "transparent",
            boxShadow: isFocused ? "transparent" : isFocused
        });
    },
    indicatorSeparator: customIndicatorSeparator,
    menu: function(styles) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, styles), {
            width: "100%",
            border: "none",
            boxShadow: "0px 1px 2px #00000029",
            marginTop: 5,
            zIndex: "999",
            fontSize: "12px"
        });
    },
    option: function(styles, param) {
        var isFocused = param.isFocused;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, styles), {
            backgroundColor: isFocused ? "#CAEAFE" : isFocused,
            borderBottom: "none",
            position: "relative",
            padding: "15px",
            color: "#595757"
        });
    },
    singleValue: customSingleValue
};
var customSelectStylesGray = {
    control: function(styles) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, styles), {
            width: "100%",
            minWidth: "148px",
            height: "100%",
            borderColor: "#e8e8e8",
            borderRadius: "6px",
            backgroundColor: "#e8e8e8",
            cursor: "pointer",
            "&:hover": {
                borderColor: "transparent"
            }
        });
    },
    indicatorSeparator: customIndicatorSeparator,
    menu: customMenu,
    option: customOption,
    singleValue: customSingleValue
};


/***/ }),

/***/ 37059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ useFormatDistanceTime; }
});

// EXTERNAL MODULE: ./src/utils/dayjs-utils.js
var dayjs_utils = __webpack_require__(76932);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDistance/index.js + 1 modules
var formatDistance = __webpack_require__(96556);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseJSON/index.js
var parseJSON = __webpack_require__(5717);
;// CONCATENATED MODULE: ./src/utils/format-time-utils.js



/**
 * NOTE: parseJSON("Fri Jun 24 03:38:08 GMT 2022") => NaN
 * parseJSON supported date string
 * ----
 * 2000-03-15T05:20:10.123Z: The output of .toISOString() and JSON.stringify(new Date())
 * 2000-03-15T05:20:10Z: Without milliseconds
 * 2000-03-15T05:20:10+00:00: With a zero offset, the default JSON encoded format in some other languages
 * 2000-03-15T05:20:10+05:45: With a positive or negative offset, the default JSON encoded format in some other languages
 * 2000-03-15T05:20:10+0000: With a zero offset without a colon
 * 2000-03-15T05:20:10: Without a trailing 'Z' symbol
 * 2000-03-15T05:20:10.1234567: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * 2000-03-15 05:20:10: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 * ---
 */ var getUtcTime = function() {
    var now = new Date();
    var utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
    return utc;
};
var formatDistanceTime = function(targetTime, dateLocale) {
    try {
        var targetDateTime;
        if (String(targetTime).includes("T") || String(targetTime).includes("+")) {
            // 2022-07-15T03:30:44.000+0000
            var parseLocalTime = (0,parseJSON/* default */.Z)((0,dayjs_utils/* default */.ZP)(targetTime || new Date()).format()); // local time
            targetDateTime = new Date(parseLocalTime.getTime() + parseLocalTime.getTimezoneOffset() * 60000); // to utc time
        } else {
            // 2022-08-03 05:42:59
            var parseTime = (0,parseJSON/* default */.Z)((0,dayjs_utils/* default */.ZP)(targetTime || new Date()).format()); // parse time is utc
            targetDateTime = new Date(parseTime);
        }
        var theUtcTime = getUtcTime();
        return (0,formatDistance/* default */.Z)(targetDateTime, theUtcTime, {
            addSuffix: true,
            locale: dateLocale,
            includeSeconds: true
        });
    } catch (error) {
        return "-";
    }
};

// EXTERNAL MODULE: ./src/utils/hooks/use-fns-language.js
var use_fns_language = __webpack_require__(26834);
;// CONCATENATED MODULE: ./src/utils/hooks/use-format-distance-time.js


var useFormatDistanceTime = function() {
    var dateLocale = (0,use_fns_language/* useFnsLanguage */.Y)();
    var localeFormatDistanceTime = function(targetTime) {
        return formatDistanceTime(targetTime, dateLocale);
    };
    return localeFormatDistanceTime;
};


/***/ }),

/***/ 98981:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blue11":"#00aced","blue900":"#395798","blue800":"#126bc4","blue700":"#0083e5","blue600":"#0099ef","blue500":"#00adef","blue400":"#23c2ff","blue300":"#56d0ff","blue200":"#89deff","blue100":"#abe8ff","blue50":"#caeafe","green900":"#60a127","green800":"#72ae37","green700":"#7cb540","green600":"#87bd4a","green500":"#8fc351","green400":"#a0cc6b","green300":"#b1d585","green200":"#c7e1a8","green100":"#ddedcb","green50":"#f2f8ea","purple900":"#5a4483","purple800":"#6d5793","purple700":"#77619c","purple600":"#826ca6","purple500":"#8a74ad","purple400":"#9c89b9","purple300":"#ad9ec6","purple200":"#c5bad6","purple100":"#dcd5e6","purple50":"#f1eef5","yellow900":"#ffa102","yellow800":"#ffae04","yellow700":"#ffb505","yellow600":"#ffbd06","yellow500":"#ffc307","yellow400":"#ffcc2c","yellow300":"#ffd551","yellow200":"#ffe183","yellow100":"#ffedb5","yellow50":"#fff8e1","red900":"#db3631","red800":"#e14842","red700":"#e4524c","red600":"#e75c56","red500":"#ea645e","red400":"#ed7b76","red300":"#f0938e","red200":"#f5b2af","red100":"#f9d1cf","red50":"#fcecec","gray01":"#fafafa","gray02":"#efefef","gray900":"#3f3f3f","gray800":"#4d4c4c","gray700":"#595757","gray600":"#666565","gray500":"#727171","gray400":"#878686","gray300":"#9fa0a0","gray200":"#b5b5b6","gray100":"#c9caca","gray50":"#e8e8e8","gray30":"#f1f1f1","gray15":"#f9f9f9","orderStateCOMPLETED":"AnnotationViewer_orderStateCOMPLETED__AO6y1","orderStatePROCESSING":"AnnotationViewer_orderStatePROCESSING__kLEwT","userHeaderIcon":"AnnotationViewer_userHeaderIcon__rWR8T","circleWrapper":"AnnotationViewer_circleWrapper__YUR9W","lightBlueBg":"AnnotationViewer_lightBlueBg__j9Yhq","authModalContentWrapper":"AnnotationViewer_authModalContentWrapper__FTc9p","contentHeader":"AnnotationViewer_contentHeader__8ZdZt","detail":"AnnotationViewer_detail__fKTE1","avatar":"AnnotationViewer_avatar__62c2Q","avatarWrapper":"AnnotationViewer_avatarWrapper__n8JlK","email":"AnnotationViewer_email__G8EVM","forgetPassword":"AnnotationViewer_forgetPassword__IDXkF","eyes":"AnnotationViewer_eyes__hheTh","adjustAuthDialog":"AnnotationViewer_adjustAuthDialog__WB6v0","MuiDialogPaper":"AnnotationViewer_MuiDialogPaper__tQSgV","imgBox":"AnnotationViewer_imgBox__X9KM7","videoTime":"AnnotationViewer_videoTime__0v1RH","iconType":"AnnotationViewer_iconType__ivyio","avatarBox":"AnnotationViewer_avatarBox__1RbRn","nameBox":"AnnotationViewer_nameBox__miGsZ","cusProgressBar":"AnnotationViewer_cusProgressBar__Qjjgg","tabLayout":"AnnotationViewer_tabLayout__C_4aY","tabList":"AnnotationViewer_tabList__ZXZD6","tab":"AnnotationViewer_tab__29CHH","tabSelected":"AnnotationViewer_tabSelected__Us4nz","tabHidden":"AnnotationViewer_tabHidden__HDn_v","cusTabList":"AnnotationViewer_cusTabList__7buOX","myContentTab":"AnnotationViewer_myContentTab__kdC9Z","subContent":"AnnotationViewer_subContent__05Hx_","subContentText":"AnnotationViewer_subContentText__doUoH","countText":"AnnotationViewer_countText__1WjcQ","subTitle":"AnnotationViewer_subTitle__qZQS_","title":"AnnotationViewer_title__LLOhK","orderBilling":"AnnotationViewer_orderBilling__CuNMX","cusMenuItem":"AnnotationViewer_cusMenuItem__sMMSO","pointer":"AnnotationViewer_pointer__AhTwX","defaultCursor":"AnnotationViewer_defaultCursor__4EzL4","mb_5":"AnnotationViewer_mb_5__vCvSf","custom_truncate":"AnnotationViewer_custom_truncate__lFT47","studio_info":"AnnotationViewer_studio_info__oD_mc","studio_info_wrapper":"AnnotationViewer_studio_info_wrapper__gnJ_w","title_main":"AnnotationViewer_title_main__RVRdY","wrapper":"AnnotationViewer_wrapper__KhoTd","annotationSectionMarkerWrapper":"AnnotationViewer_annotationSectionMarkerWrapper__JTgQh","controller":"AnnotationViewer_controller__86W_q","resultText":"AnnotationViewer_resultText__odddf","icon":"AnnotationViewer_icon__aXkzU","annotationSectionMarker":"AnnotationViewer_annotationSectionMarker__mtMy5","annotationPoint":"AnnotationViewer_annotationPoint__y97G2","annotationPointFocus":"AnnotationViewer_annotationPointFocus__Aifiz","blue":"AnnotationViewer_blue__PSG03","green":"AnnotationViewer_green__6foml","purple":"AnnotationViewer_purple__cdhaq","origin":"AnnotationViewer_origin__zcxYw","navyBlue":"AnnotationViewer_navyBlue__ZK6bK","annotationCard":"AnnotationViewer_annotationCard__Zy8Fk","star":"AnnotationViewer_star__wv6wU","annotationContent":"AnnotationViewer_annotationContent__MgQV4","annotationCardWrapper":"AnnotationViewer_annotationCardWrapper__vt5Oe"};

/***/ }),

/***/ 84697:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blue11":"#00aced","blue900":"#395798","blue800":"#126bc4","blue700":"#0083e5","blue600":"#0099ef","blue500":"#00adef","blue400":"#23c2ff","blue300":"#56d0ff","blue200":"#89deff","blue100":"#abe8ff","blue50":"#caeafe","green900":"#60a127","green800":"#72ae37","green700":"#7cb540","green600":"#87bd4a","green500":"#8fc351","green400":"#a0cc6b","green300":"#b1d585","green200":"#c7e1a8","green100":"#ddedcb","green50":"#f2f8ea","purple900":"#5a4483","purple800":"#6d5793","purple700":"#77619c","purple600":"#826ca6","purple500":"#8a74ad","purple400":"#9c89b9","purple300":"#ad9ec6","purple200":"#c5bad6","purple100":"#dcd5e6","purple50":"#f1eef5","yellow900":"#ffa102","yellow800":"#ffae04","yellow700":"#ffb505","yellow600":"#ffbd06","yellow500":"#ffc307","yellow400":"#ffcc2c","yellow300":"#ffd551","yellow200":"#ffe183","yellow100":"#ffedb5","yellow50":"#fff8e1","red900":"#db3631","red800":"#e14842","red700":"#e4524c","red600":"#e75c56","red500":"#ea645e","red400":"#ed7b76","red300":"#f0938e","red200":"#f5b2af","red100":"#f9d1cf","red50":"#fcecec","gray01":"#fafafa","gray02":"#efefef","gray900":"#3f3f3f","gray800":"#4d4c4c","gray700":"#595757","gray600":"#666565","gray500":"#727171","gray400":"#878686","gray300":"#9fa0a0","gray200":"#b5b5b6","gray100":"#c9caca","gray50":"#e8e8e8","gray30":"#f1f1f1","gray15":"#f9f9f9","orderStateCOMPLETED":"ResultItem_orderStateCOMPLETED__iFczP","orderStatePROCESSING":"ResultItem_orderStatePROCESSING__lJqNo","userHeaderIcon":"ResultItem_userHeaderIcon__TkXgk","circleWrapper":"ResultItem_circleWrapper__xaAh_","lightBlueBg":"ResultItem_lightBlueBg__TOBOB","authModalContentWrapper":"ResultItem_authModalContentWrapper__x4AVQ","contentHeader":"ResultItem_contentHeader__6DWN6","detail":"ResultItem_detail__JSL_o","avatar":"ResultItem_avatar__jR1vr","avatarWrapper":"ResultItem_avatarWrapper___gv9o","email":"ResultItem_email__SZFPJ","forgetPassword":"ResultItem_forgetPassword__rYugR","eyes":"ResultItem_eyes__TXeAw","adjustAuthDialog":"ResultItem_adjustAuthDialog__shSd0","MuiDialogPaper":"ResultItem_MuiDialogPaper__TiIoI","imgBox":"ResultItem_imgBox__LLekZ","videoTime":"ResultItem_videoTime__swZr1","iconType":"ResultItem_iconType__Midry","avatarBox":"ResultItem_avatarBox__wV4g1","nameBox":"ResultItem_nameBox__eIk7p","cusProgressBar":"ResultItem_cusProgressBar__v4XyD","tabLayout":"ResultItem_tabLayout__mu_OW","tabList":"ResultItem_tabList__mmu6i","tab":"ResultItem_tab__ioxAF","tabSelected":"ResultItem_tabSelected__AjrKh","tabHidden":"ResultItem_tabHidden__IS0FS","cusTabList":"ResultItem_cusTabList__uVGuF","myContentTab":"ResultItem_myContentTab__Fay_z","subContent":"ResultItem_subContent__1gj4k","subContentText":"ResultItem_subContentText__hj4Pc","countText":"ResultItem_countText__BD4Ci","subTitle":"ResultItem_subTitle__nPJXC","title":"ResultItem_title__zZ9vE","orderBilling":"ResultItem_orderBilling__MvlMm","cusMenuItem":"ResultItem_cusMenuItem__jpZbl","pointer":"ResultItem_pointer__2gb6b","defaultCursor":"ResultItem_defaultCursor__ZtgJ_","mb_5":"ResultItem_mb_5__taXed","custom_truncate":"ResultItem_custom_truncate__2nEIY","studio_info":"ResultItem_studio_info__ohgoV","studio_info_wrapper":"ResultItem_studio_info_wrapper__43XEg","title_main":"ResultItem_title_main__tzK_I","wrapper":"ResultItem_wrapper__IW7i_","itemWrapper":"ResultItem_itemWrapper__lASwl","itemWrapperInner":"ResultItem_itemWrapperInner__E_q0d","videoWrapper":"ResultItem_videoWrapper__UTNKT","img":"ResultItem_img__e6IWv","icon":"ResultItem_icon__Yayb1","contentWrapper":"ResultItem_contentWrapper__GkFnK","itemType":"ResultItem_itemType__ojfXD","TypeBox":"ResultItem_TypeBox__TS8K4","typeText":"ResultItem_typeText__zPYHf","levelBox":"ResultItem_levelBox__ZlTg5","levelText":"ResultItem_levelText__O1O_E","dataScience":"ResultItem_dataScience__B9zXe","disc":"ResultItem_disc__weUKk","author":"ResultItem_author__iPaq_","publishedTime":"ResultItem_publishedTime__MYlkL","priceItem":"ResultItem_priceItem__7P9YG","bottomWrapper":"ResultItem_bottomWrapper__ZGyGa","controller":"ResultItem_controller__9I6h4","resultText":"ResultItem_resultText__PmU_l","itemData":"ResultItem_itemData__u__d2","subResultItem":"ResultItem_subResultItem__hwKFo","secTitle":"ResultItem_secTitle__VWdwH","covered":"ResultItem_covered__YH4IG","tags":"ResultItem_tags__pMvx7","sectionCoveredItem":"ResultItem_sectionCoveredItem__pQDPq","blue":"ResultItem_blue__PsyCl","green":"ResultItem_green__SpvH_","purple":"ResultItem_purple__vjaom","origin":"ResultItem_origin__dymfq","navyBlue":"ResultItem_navyBlue__YZqFT","keyWord":"ResultItem_keyWord__Lpr0A","annotationWrapper":"ResultItem_annotationWrapper__h2hXQ"};

/***/ }),

/***/ 90636:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blue11":"#00aced","blue900":"#395798","blue800":"#126bc4","blue700":"#0083e5","blue600":"#0099ef","blue500":"#00adef","blue400":"#23c2ff","blue300":"#56d0ff","blue200":"#89deff","blue100":"#abe8ff","blue50":"#caeafe","green900":"#60a127","green800":"#72ae37","green700":"#7cb540","green600":"#87bd4a","green500":"#8fc351","green400":"#a0cc6b","green300":"#b1d585","green200":"#c7e1a8","green100":"#ddedcb","green50":"#f2f8ea","purple900":"#5a4483","purple800":"#6d5793","purple700":"#77619c","purple600":"#826ca6","purple500":"#8a74ad","purple400":"#9c89b9","purple300":"#ad9ec6","purple200":"#c5bad6","purple100":"#dcd5e6","purple50":"#f1eef5","yellow900":"#ffa102","yellow800":"#ffae04","yellow700":"#ffb505","yellow600":"#ffbd06","yellow500":"#ffc307","yellow400":"#ffcc2c","yellow300":"#ffd551","yellow200":"#ffe183","yellow100":"#ffedb5","yellow50":"#fff8e1","red900":"#db3631","red800":"#e14842","red700":"#e4524c","red600":"#e75c56","red500":"#ea645e","red400":"#ed7b76","red300":"#f0938e","red200":"#f5b2af","red100":"#f9d1cf","red50":"#fcecec","gray01":"#fafafa","gray02":"#efefef","gray900":"#3f3f3f","gray800":"#4d4c4c","gray700":"#595757","gray600":"#666565","gray500":"#727171","gray400":"#878686","gray300":"#9fa0a0","gray200":"#b5b5b6","gray100":"#c9caca","gray50":"#e8e8e8","gray30":"#f1f1f1","gray15":"#f9f9f9","itemContainer":"ResultItemLayout_itemContainer__St_mo"};

/***/ }),

/***/ 9542:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blue11":"#00aced","blue900":"#395798","blue800":"#126bc4","blue700":"#0083e5","blue600":"#0099ef","blue500":"#00adef","blue400":"#23c2ff","blue300":"#56d0ff","blue200":"#89deff","blue100":"#abe8ff","blue50":"#caeafe","green900":"#60a127","green800":"#72ae37","green700":"#7cb540","green600":"#87bd4a","green500":"#8fc351","green400":"#a0cc6b","green300":"#b1d585","green200":"#c7e1a8","green100":"#ddedcb","green50":"#f2f8ea","purple900":"#5a4483","purple800":"#6d5793","purple700":"#77619c","purple600":"#826ca6","purple500":"#8a74ad","purple400":"#9c89b9","purple300":"#ad9ec6","purple200":"#c5bad6","purple100":"#dcd5e6","purple50":"#f1eef5","yellow900":"#ffa102","yellow800":"#ffae04","yellow700":"#ffb505","yellow600":"#ffbd06","yellow500":"#ffc307","yellow400":"#ffcc2c","yellow300":"#ffd551","yellow200":"#ffe183","yellow100":"#ffedb5","yellow50":"#fff8e1","red900":"#db3631","red800":"#e14842","red700":"#e4524c","red600":"#e75c56","red500":"#ea645e","red400":"#ed7b76","red300":"#f0938e","red200":"#f5b2af","red100":"#f9d1cf","red50":"#fcecec","gray01":"#fafafa","gray02":"#efefef","gray900":"#3f3f3f","gray800":"#4d4c4c","gray700":"#595757","gray600":"#666565","gray500":"#727171","gray400":"#878686","gray300":"#9fa0a0","gray200":"#b5b5b6","gray100":"#c9caca","gray50":"#e8e8e8","gray30":"#f1f1f1","gray15":"#f9f9f9","orderStateCOMPLETED":"ResultNotFound_orderStateCOMPLETED__9Tynk","orderStatePROCESSING":"ResultNotFound_orderStatePROCESSING__ojw9e","userHeaderIcon":"ResultNotFound_userHeaderIcon__0eVPO","circleWrapper":"ResultNotFound_circleWrapper__P7xSz","lightBlueBg":"ResultNotFound_lightBlueBg__Ew7VT","authModalContentWrapper":"ResultNotFound_authModalContentWrapper__B18tb","contentHeader":"ResultNotFound_contentHeader__dDsl_","detail":"ResultNotFound_detail__TcRr0","avatar":"ResultNotFound_avatar__Iml7U","avatarWrapper":"ResultNotFound_avatarWrapper__628zY","email":"ResultNotFound_email__MQngS","forgetPassword":"ResultNotFound_forgetPassword__wBrZc","eyes":"ResultNotFound_eyes__p_rxs","adjustAuthDialog":"ResultNotFound_adjustAuthDialog__9uxrd","MuiDialogPaper":"ResultNotFound_MuiDialogPaper__O070c","imgBox":"ResultNotFound_imgBox__HhKor","videoTime":"ResultNotFound_videoTime__LSd9d","iconType":"ResultNotFound_iconType__STtcx","avatarBox":"ResultNotFound_avatarBox__bCv9V","nameBox":"ResultNotFound_nameBox__AFOfT","cusProgressBar":"ResultNotFound_cusProgressBar__NJ7Cx","tabLayout":"ResultNotFound_tabLayout__NmWbL","tabList":"ResultNotFound_tabList__hIDNo","tab":"ResultNotFound_tab__2CrYi","tabSelected":"ResultNotFound_tabSelected__HZOiZ","tabHidden":"ResultNotFound_tabHidden__2Vl72","cusTabList":"ResultNotFound_cusTabList__H4Lch","myContentTab":"ResultNotFound_myContentTab__d5YVD","subContent":"ResultNotFound_subContent__p6Nh_","subContentText":"ResultNotFound_subContentText__JFPN_","countText":"ResultNotFound_countText__mR5Mw","subTitle":"ResultNotFound_subTitle__81wyX","title":"ResultNotFound_title__ILuwF","orderBilling":"ResultNotFound_orderBilling__mrlc8","cusMenuItem":"ResultNotFound_cusMenuItem__YvdZJ","pointer":"ResultNotFound_pointer__kqwbG","defaultCursor":"ResultNotFound_defaultCursor__bN6dS","mb_5":"ResultNotFound_mb_5__FgoQo","custom_truncate":"ResultNotFound_custom_truncate__IbrcK","studio_info":"ResultNotFound_studio_info__R7aAB","studio_info_wrapper":"ResultNotFound_studio_info_wrapper__UmC01","title_main":"ResultNotFound_title_main__dNkEF","wrapper":"ResultNotFound_wrapper__MFVoL","resultNotFoundPage":"ResultNotFound_resultNotFoundPage__JR4H4","notFoundPageInner":"ResultNotFound_notFoundPageInner__0nid0","content":"ResultNotFound_content__aDKtC"};

/***/ }),

/***/ 32425:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blue11":"#00aced","blue900":"#395798","blue800":"#126bc4","blue700":"#0083e5","blue600":"#0099ef","blue500":"#00adef","blue400":"#23c2ff","blue300":"#56d0ff","blue200":"#89deff","blue100":"#abe8ff","blue50":"#caeafe","green900":"#60a127","green800":"#72ae37","green700":"#7cb540","green600":"#87bd4a","green500":"#8fc351","green400":"#a0cc6b","green300":"#b1d585","green200":"#c7e1a8","green100":"#ddedcb","green50":"#f2f8ea","purple900":"#5a4483","purple800":"#6d5793","purple700":"#77619c","purple600":"#826ca6","purple500":"#8a74ad","purple400":"#9c89b9","purple300":"#ad9ec6","purple200":"#c5bad6","purple100":"#dcd5e6","purple50":"#f1eef5","yellow900":"#ffa102","yellow800":"#ffae04","yellow700":"#ffb505","yellow600":"#ffbd06","yellow500":"#ffc307","yellow400":"#ffcc2c","yellow300":"#ffd551","yellow200":"#ffe183","yellow100":"#ffedb5","yellow50":"#fff8e1","red900":"#db3631","red800":"#e14842","red700":"#e4524c","red600":"#e75c56","red500":"#ea645e","red400":"#ed7b76","red300":"#f0938e","red200":"#f5b2af","red100":"#f9d1cf","red50":"#fcecec","gray01":"#fafafa","gray02":"#efefef","gray900":"#3f3f3f","gray800":"#4d4c4c","gray700":"#595757","gray600":"#666565","gray500":"#727171","gray400":"#878686","gray300":"#9fa0a0","gray200":"#b5b5b6","gray100":"#c9caca","gray50":"#e8e8e8","gray30":"#f1f1f1","gray15":"#f9f9f9","btnLogin":"explore_btnLogin__yt_iE","iconBox":"explore_iconBox__0NZaF","right":"explore_right__y7DoD","left":"explore_left__OwSvw","pageFabButton":"explore_pageFabButton__6KaLD","loading":"explore_loading__OwfHQ","buttonText":"explore_buttonText__kgpfb","backToTop":"explore_backToTop__8XtTZ","rwdButton":"explore_rwdButton__UUIPg","largeButton":"explore_largeButton__IVQPl","smallButton":"explore_smallButton__rVQWN","explore":"explore_explore__dWGLA","academyLayout":"explore_academyLayout__PFwt0","academyLayoutInner":"explore_academyLayoutInner__nJbiq","categoriesWrapper":"explore_categoriesWrapper__oeteP","cardWrapper":"explore_cardWrapper__d7Lz8","secTitle":"explore_secTitle__Xq11F","viewAllCard":"explore_viewAllCard___eYxY","cardWrapperInner":"explore_cardWrapperInner__E2Gjo","carouselCard":"explore_carouselCard__jg_C2","searchWrapper":"explore_searchWrapper__J3GMp"};

/***/ }),

/***/ 90365:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blue11":"#00aced","blue900":"#395798","blue800":"#126bc4","blue700":"#0083e5","blue600":"#0099ef","blue500":"#00adef","blue400":"#23c2ff","blue300":"#56d0ff","blue200":"#89deff","blue100":"#abe8ff","blue50":"#caeafe","green900":"#60a127","green800":"#72ae37","green700":"#7cb540","green600":"#87bd4a","green500":"#8fc351","green400":"#a0cc6b","green300":"#b1d585","green200":"#c7e1a8","green100":"#ddedcb","green50":"#f2f8ea","purple900":"#5a4483","purple800":"#6d5793","purple700":"#77619c","purple600":"#826ca6","purple500":"#8a74ad","purple400":"#9c89b9","purple300":"#ad9ec6","purple200":"#c5bad6","purple100":"#dcd5e6","purple50":"#f1eef5","yellow900":"#ffa102","yellow800":"#ffae04","yellow700":"#ffb505","yellow600":"#ffbd06","yellow500":"#ffc307","yellow400":"#ffcc2c","yellow300":"#ffd551","yellow200":"#ffe183","yellow100":"#ffedb5","yellow50":"#fff8e1","red900":"#db3631","red800":"#e14842","red700":"#e4524c","red600":"#e75c56","red500":"#ea645e","red400":"#ed7b76","red300":"#f0938e","red200":"#f5b2af","red100":"#f9d1cf","red50":"#fcecec","gray01":"#fafafa","gray02":"#efefef","gray900":"#3f3f3f","gray800":"#4d4c4c","gray700":"#595757","gray600":"#666565","gray500":"#727171","gray400":"#878686","gray300":"#9fa0a0","gray200":"#b5b5b6","gray100":"#c9caca","gray50":"#e8e8e8","gray30":"#f1f1f1","gray15":"#f9f9f9","btnLogin":"relevance_btnLogin__FUgDY","iconBox":"relevance_iconBox__KaNTg","right":"relevance_right__LxMEy","left":"relevance_left__NwyrD","pageFabButton":"relevance_pageFabButton__v7GgK","loading":"relevance_loading__yZA3e","buttonText":"relevance_buttonText__WzOQC","backToTop":"relevance_backToTop__xqimR","rwdButton":"relevance_rwdButton___Pgc6","largeButton":"relevance_largeButton__qy_tI","smallButton":"relevance_smallButton__IB0Jz","relevancePage":"relevance_relevancePage__GodMa","searchWrapper":"relevance_searchWrapper__63Mey","relevancePageInner":"relevance_relevancePageInner__vbGTu","topWrapper":"relevance_topWrapper__wnYcd","searchResult":"relevance_searchResult__HrK27","sortItem":"relevance_sortItem__29ki_","relevanceContainer":"relevance_relevanceContainer__9sOcU","loadingWrapper":"relevance_loadingWrapper__krYBY"};

/***/ })

}]);